export const ANNOUNCEMENT = 'ANNOUNCEMENT';
export const RELEASE_NOTE = 'RELEASE_NOTE';
export const GOAL = 'GOAL';
export const VISUAL = 'VISUAL';
